import { Drawer } from '@mui/material';
import React from 'react';

import NavBar from './NavBar';

export default function DesktopNavDrawer(props: { drawerWidth: number }) {
  return (
    <Drawer
      variant='permanent'
      sx={{
        display: { xs: 'none', sm: 'block' },
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: props.drawerWidth,
          backgroundColor: 'primary.dark',
        },
      }}
      open
    >
      <NavBar />
    </Drawer>
  );
}
